<template>
  <div class="indeCenG">
    <div class="cenGtop">
      <img src="../assets/img/guan-top.png" alt="荣誉资质">
      <div class="swipe">
      	<div class="tabTwoLeft"><p><</p></div>
      	<div class="swiper-container">
      		<div class="swiper-wrapper">
            <div class="swiper-slide"><img src="../assets/img/swiper1.png" alt=""></div>
      			<div class="swiper-slide"><img src="../assets/img/swiper2.png" alt=""></div>
      		</div>
          <div class="swiper-pagination"></div>
      	</div>
      	<div class="tabTwoRight"><p>></p></div>
      </div>
    </div>
    <h2>荣誉资质</h2>
    <ul>
      <li>
        <div><img src="../assets/img/guan-cen1.png" alt="软著"><h4>软著</h4></div>
        <p>2017年10月，禧九通过自主研发软件产品取得了3个计算机软件著作权。</p>
      </li>
      <li>
        <div><img src="../assets/img/guan-cen2.png" alt="SP"><h4>SP</h4></div>
        <p>2017年9月获得增值电信业务经营许可证中的第二类增值电信业务中的呼叫中心业务、信息服务业务。</p>
      </li>
      <li>
        <div><img src="../assets/img/guan-cen3.png" alt="文网文"><h4>文网文</h4></div>
        <p>2017年9月获得网络文化经营许可证。</p>
      </li>
      <li>
        <div><img src="../assets/img/guan-cen4.png" alt="码号"><h4>码号</h4></div>
        <p>2018年2月获得短消息服务接入代码。</p>
      </li>
      <li>
        <div><img src="../assets/img/guan-cen5.png" alt="ICP"><h4>ICP</h4></div>
        <p>2018年4月获得增值电信业务经营许可证中的第二类增值电信业务中的互联网信息服务。</p>
      </li>
      <li>
        <div><img src="../assets/img/guan-cen6.png" alt="代理商"><h4>代理商</h4></div>
        <p>2018年双十一代理商店铺第一名，最佳合作奖。</p>
      </li>
    </ul>
    <p class="beianPtips"><span @click="goBeian">陕ICP备15007224号  出版物网络交易平台服务经营备案号：新出发批兼零字第023号</span></p>
  </div>
</template>

<script>
  import Swiper from 'swiper';

  export default {
  	name: 'indexCenterG',
  	data () {
  		return {

  		}
  	},
    mounted:function(){
    	var myswiper = new Swiper ('.swiper-container', {
        autoplay: {
          delay: 5000,
        },
    		navigation: {
    			nextEl: '.tabTwoRight',
    			prevEl: '.tabTwoLeft',
    			disabledClass: 'my-disabled',
    		},
        pagination: {
          el: '.swiper-pagination',
        },
      });
    },
  	methods:{
      goBeian(){
        window.location.href = 'http://www.beian.miit.gov.cn';
      },
  	}
  }
</script>

<style scoped lang="scss">
  .indeCenG{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .beianPtips{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      color: #3a3a3a;
      text-align: center;
      span:hover{
        color: #000;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .cenGtop{
      background: url(../assets/img/he-bg.png) no-repeat;
      background-size: cover;
      width: 100%;
      height: 26rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width: 20rem;
        margin-top: 3rem;
      }
      .swipe{
      	display: flex;
      	align-items: center;
        justify-content: space-between;
        width: 65%;
      	.tabTwoLeft,.tabTwoRight{
          cursor: pointer;
      		width: 2rem;
      		height: 3rem;
      		display: flex;
      		justify-content: center;
      		align-items: center;
      		background: #fff;
          border: 1px solid #e9e9e9;
      		border-radius: .6rem;
      		outline: none;
      		p{
      			font-size: 1.6rem;
      			color: #bbb;
      		}
      	}
      	.swiper-container{
      		padding: 1rem 0;
      		width: 90%;
      		.swiper-wrapper{
            margin-bottom: 1rem;
      			.swiper-slide{
              img{
                width: 100%;
              }
      			}
      		}
      	}
      	.my-disabled{
      		opacity: 0.3;
      	}
      }
    }
    h2{
      margin-top: 2.2rem;
    }
    ul{
      width: 60%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 2rem 0;
      li{
        width: 33%;
        margin: .18rem 0;
        padding-bottom: 1rem;
        display: flex;
        height: 8rem;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        box-shadow: #efefef 0 0 1rem .2rem;
        div{
          display: flex;
          align-items: center;
          margin-top: 1.6rem;
          margin-bottom: 1rem;
          img{
            width: 1.8rem;
            margin-right: 1rem;
          }
        }
        p{
          padding: 0 2.6rem;
          text-align: justify;
          text-indent: 2rem;
          margin: 0;
          font-size: .9rem;
          line-height: 1.2rem;
          color: #a4a4a4;
        }
      }
    }
    @media screen and (max-width: 1700px) {
      .cenGtop{
        .swipe{
          width: 90%;
        }
      }
      ul{
        width: 90%;
      }
    }
    @media screen and (max-width: 1000px) {
      .cenGtop{
        height: 25rem;
        .swipe{
          margin-top: 1rem;
          width: 100%;
        }
      }
      ul{
        li{
          width: 49%;
        }
      }
    }
    @media screen and (max-width: 800px) {
      .cenGtop{
        height: 18rem;
        .swipe{
          margin-top: -1rem;
          .tabTwoLeft,.tabTwoRight{
            display: none;
          }
        }
      }
      ul{
        li{
          width: 100%;
        }
      }
    }
    @media screen and (max-width: 600px) {
      .cenGtop{
        height: 12rem;
        img{
          width: 60%;
          margin-top: 2rem;
        }
        .swipe{
          margin-top: -1rem;
          .tabTwoLeft,.tabTwoRight{
            display: none;
          }
        }
      }
      h2{
        font-size: 1rem;
        margin-top: 2rem;
      }
      ul{
        margin: 2rem 0;
      }
      .beianPtips{
        bottom: .5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexCenterG.vue